import * as React from 'react';
import Modal, {ModalProps} from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import AxiosConfig from '../../../utilities/AxiosConfig';
import axios from 'axios';
import { ClientItem } from '../../../pages/it_operations/ClientManagement';
import IconButton from '../../common/IconButton';
import logger from '../../../utilities/logging';
import Select from 'react-select';

export interface NewClientModalProps extends ModalProps {
    afterSave? : (data: ClientItem) => void,
    clients? : any,
    customerIds? : any,
}

const NewClientModal: React.FC<NewClientModalProps> = (props: NewClientModalProps) => {
    const [addingClient, setAddingClient] = React.useState(false);
    const [newClient, setNewClient] = React.useState({
        PortalClientId : "",
        Description : "",
        CustomerId : null,
    });

    const addClient = (e: React.SyntheticEvent) => {
        e.preventDefault();
        if(props.clients){
            if(props.clients.includes(newClient.PortalClientId)){
                alert("A client with that client id already exists. Try a different name to continue.");
                return;
            }
        }
        if(!newClient.PortalClientId || !newClient.CustomerId){
            alert("You need to provide a portal client id and customer id in order to continue.");
            return;
        }
        if(newClient.PortalClientId.includes("?")){
            alert("No special symbols are allowed in client name");
            return;
        }
        setAddingClient(true);
        //console.log("Sending this to add client endpoint", newClient);
        axios.put(process.env.REACT_APP_API_URL + "/api/portal/client", newClient, AxiosConfig.configValue("min"))
        .then((response: any) => {
            //console.log("Response from add client", response);
            if(props.afterSave){
                props.afterSave(response.data);
            }
        })
        .catch((error: any) => {
            //console.log(error, error.response);
            logger.Error({
                EventMessage : `NewClientModal -> addClient -> ${error?.reponse}`,
                EventCategort : "httprequest"
            })
            AxiosConfig.handleError(error);
        })
        .finally(() => {
            setAddingClient(false);
        })
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        setNewClient({ ...newClient, [e.target.name] : e.target.value });
    }

    const handleSelectChange = (s:any) => {
        setNewClient({ ...newClient, CustomerId : s.value });
        //console.log(newClient);
    }
    
    const modalProps = (({ afterSave, ...p }) => p)(props);
    return (
        <Modal {...modalProps} className="z-100">
            <Modal.Header>
                <Modal.Title>Create a New Client.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="w-100" as={Row}>
                        <Form.Label column sm="6">Portal Client Id</Form.Label>
                            <Col sm="6">
                                <Form.Control onChange={handleChange} name="PortalClientId" type="text" placeholder="Portal Client Id" value={newClient.PortalClientId} />
                            </Col>
                    </Form.Group>
                    <Form.Group className="w-100" as={Row}>
                        <Form.Label column sm="6">Description</Form.Label>
                            <Col sm="6">
                                <Form.Control onChange={handleChange} name="Description" type="text" placeholder="Description" value={newClient.Description} />
                            </Col>
                    </Form.Group>
                    <Form.Group className="w-100" as={Row}>
                        <Form.Label column sm="6">Customer Id :</Form.Label>
                            <Col sm="6">
                                <Select 
                                    name="CustomerId"
                                    onChange={(selection: any) => handleSelectChange(selection)}
                                    options={props.customerIds}
                                    value={props.customerIds.find((item: any) => item.value === newClient.CustomerId)}
                                />
                            </Col>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <IconButton onClick={props.onHide} buttonClassName="btn-danger" icon="close">Cancel</IconButton>
                <IconButton onClick={addClient} buttonClassName="btn-primary" showSpinner={addingClient} icon="add">Create Client</IconButton>
            </Modal.Footer>
        </Modal>
    );
}

export default NewClientModal;